import type { CardItemLitterData } from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface MtWishlistPageData {
  items: CardItemLitterData[];
  onLitterListClick?: MouseEventHandler;
  loading?: boolean;
}

export interface MtWishlistPageProps extends MtWishlistPageData {}
